import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-birthdate-divided',
    templateUrl: './birthdate-divided.component.html',
    styleUrls: ['./birthdate-divided.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, NgxIntlTelInputModule, NgFor, MatOptionModule, NgIf, DatePipe, TranslateModule]
})
export class BirthdateDividedComponent implements OnInit {

  // Accepte "birthdate" ou "future"
  @Input() private type: string;

  // Required.
  @Input() public birthdate: string;

  // Optionnel. Prévient le champ d'être centré sur la valeur sélectionnée.
  @Input() public disableCentering: boolean = false;

  // Optionnel. les class sont à mettre/présentes dans le styles-imports-composants.scss, partie "mat select".
  @Input() public panelClass: string = '';

  @Output() public newBirthdate: any = new EventEmitter;

  public dateForm: UntypedFormGroup;
  public dayControl: UntypedFormControl = new UntypedFormControl('', Validators.required);
  public monthControl: UntypedFormControl = new UntypedFormControl('', Validators.required);
  public yearControl: UntypedFormControl =  new UntypedFormControl('', Validators.required);

  constructor(
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
    if (this.birthdate) {
      const splitBirthdate = this.birthdate.split('-');
      this.yearControl.setValue(splitBirthdate[0]);
      this.monthControl.setValue(splitBirthdate[1]);
      this.dayControl.setValue(splitBirthdate[2]);
    }
    this.dateForm = new UntypedFormGroup({});
    this.dateForm.addControl('dayControl', this.dayControl);
    this.dateForm.addControl('monthControl', this.monthControl);
    this.dateForm.addControl('yearControl', this.yearControl);
    this.dateForm.valueChanges.subscribe( data => {
      this.newBirthdate.emit(data);
    } );
  }

  defaultSelect(o1: any, o2: any) { return o1 == o2; }

  // BIRTHDATE FORM SELECTS
  createBirthdate(range) {
    const table = []
    let i = 0;
    let end;
    if (range === 'days') {
      i = 1;
      end = 32;
    }
    if (range === 'months') {
      end = 12;
    }
    if (range === 'years') {
      const current = new Date();
      if (this.type && this.type === 'birthdate') {
        i = 1942;
        end = current.getFullYear() - 10;
      } else if (this.type === 'future') {
        i = current.getFullYear();
        end = current.getFullYear() + 5;
      } else if (this.type === 'admin') {
        i = current.getFullYear() -1;
        end = current.getFullYear() + 5
      }
      else {
        i = 1980;
        end = current.getFullYear() + 5;
      }
    }
    do {
      table.push(i);
      i++;
    } while (i !== end)
    return table;
  }

  returnMonthName(n : number) {
    const date = new Date(2021, n, 1);
    return date.toDateString();
  }




}
